export default __webpack_public_path__ + "static/heroSectionRightImage-87bc876ca51db91555c9c0f790966def.webp";